export default __webpack_public_path__ + "static/media/ceres-home.61a3de66.png";